// Based on bolt-server/src/delivery/provider/delivery_provider_portal/main/constants/ResponseCodes.ts
// and bolt-server/src/delivery/provider/delivery_provider/main/config/ResponseCodes.ts
export class CommonResponseCodes {
  public static readonly OK: number = 0;
  public static readonly INVALID_REQUEST: number = 702;
}
export class ResponseCodes extends CommonResponseCodes {
  public static readonly INVALID_PERMISSIONS = 5801;
  public static readonly PROVIDER_ACCOUNT_INVALID_CREDENTIALS = 5877;
  public static readonly PROVIDER_ACCOUNT_LOCKED = 5887;
  public static readonly NOT_FOUND_IN_CACHE = 301700;
  public static readonly UPDATES_FROM_OLD_MENU = 6001;
  public static readonly OPTIMISTIC_CONCURRENCY_ERROR = 992;
}
